import { render, staticRenderFns } from "./excessList.vue?vue&type=template&id=9779ca8c"
import script from "./excessList.vue?vue&type=script&lang=js"
export * from "./excessList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports